import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register('/service-worker.js', {
        updateViaCache: 'none',
      });

      console.log('SW registered:', registration);

      await registration.update();

      const notifyNewVersionWhenControlled = () => {
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          if (window.__swControllerChanged) return;
          window.__swControllerChanged = true;

          window.dispatchEvent(
            new CustomEvent('odontoassist:new-version-available')
          );
        });
      };

      notifyNewVersionWhenControlled();

      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (!newWorker) return;

        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            newWorker.postMessage({ type: 'SKIP_WAITING' });
          }
        });
      });
    } catch (error) {
      console.log('SW registration failed:', error);
    }
  });
}